import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { AccountExtraitTransactions } from '../../../../transaction/src/domain/Transaction/entities/AccountExtraitTransaction/AccountExtraitTransactionResponseDTO';
import { Account, AccountDetails } from '../../domain/Account/entities';

export type AccountExtraitTransactionListFilters = {
  pageSize: number;
  pageOffset: number;
  allEntries?: string;
  dateFrom?: string;
  dateTo?: string;
  fromAmount?: string;
  toAmount?: string;
  transactionType?: number;
};

export type AccountDetailsState = {
  selectedAccountDetails: Nullable<AccountDetails>;
  selectedAccount: Nullable<Account>;
  accountExtraitTransactionListData?: Nullable<AccountExtraitTransactions>;
  onAccountSelect: (propertyValue: string | number, propertyName?: 'accountNumber' | 'accountId') => void;
  accountExtraitTransactionListFilters: Partial<AccountExtraitTransactionListFilters>;
  onResetTransactionListFilters: () => void;
  onRefetchAccountDetails: () => void;
  onRefetchAccountExtraitTransactionList: () => void;
  onTransactionListFiltersChange: (
    filters: Partial<AccountExtraitTransactionListFilters>,
    nextPage?: number,
    totalPages?: number,
  ) => void;
  loadingState: {
    isLoadingAccountDetails: boolean;
    isLoadingAccountExtraitTransactionList: boolean;
  };
  errorState: {
    accountDetailsError?: AxiosError<APIGatewayResponse<any>, any>;
    accountExtraitTransactionListError?: AxiosError<APIGatewayResponse<any>, any>;
  };
  lastPaginationPageVisited: number;
  onSetLastPaginationPageVisited: (value: number) => void;
};

export interface AccountDetailsProviderProps {}

export enum AccountDetailsContextActionTypes {
  SetSelectedAccountDetails = '@@AccountDetails/SetSelectedAccountDetails',
  SetSelectedAccount = '@@AccountDetails/SetSelectedAccount',
  onAccountExtraitSelectTransaction = '@@/AccountDetails/onAccountExtraitSelectTransaction',
  setSelectedAccountExtraitTransaction = '@@/AccountDetails/setSelectedAccountExtraitTransaction',
  setAccountExtraitTransactionListFilters = '@@/AccountDetails/setAccountExtraitTransactionListFilters',
  setLastPaginationPageVisited = '@@/AccountDetails/setLastPaginationPageVisited',
}
